import React from "react";

interface ImageCardProps {
  imageUrl: string;
  alt?: string;
}

const ImageCard: React.FC<ImageCardProps> = ({
  imageUrl,
  alt = "Food Image",
}) => {
  return (
    <div className="relative w-[93.0083px] h-[70px]">
      {/* Layer 3 - bottom background layer  */}
      <div
        className="absolute bg-[#606164] rounded"
        style={{
          width: "82.5772px",
          height: "57.8178px",
          top: "6.42px",
          left: "21.72px",
          transform: "rotate(2.6deg)",
        }}
      />

      {/* Layer 2 - middle background layer */}
      <div
        className="absolute bg-[#46474A] rounded"
        style={{
          width: "85.6655px",
          height: "64.2491px",
          top: "1.15px",
          left: "14.35px",
          transform: "rotate(2.6deg)",
        }}
      />

      {/* Image layer */}
      <img
        src={imageUrl}
        alt={alt}
        className="relative w-[93.0083px] h-[70px] object-cover rounded z-10"
      />
    </div>
  );
};

export default ImageCard;
